import React, { useState, useEffect } from "react";
import "../layout.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import NotificationBell from "../components/NotificationBell";
import NotificationPopup from '../components/NotificationPop'; // adjust path as needed

function Layout({ children }) {
  const [searchInput, setSearchInput] = useState("");
  const [filteredMenu, setFilteredMenu] = useState([]);
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 768);
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
    }
  }, [navigate]);


useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setCollapsed(true);  // Always collapse on small screen
    }
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);



useEffect(() => {
  if (window.innerWidth <= 768) {
    setCollapsed(true);  // Collapse on page change for small screens
  }
}, [location.pathname]);



  const userMenu = [
    {
      name: "Home",
      path: "/",
      icon: "ri-home-6-line",
    },
    {
      name: "Appointment",
      path: "/appointments",
      icon: "ri-calendar-line",
    },
    {
      name: "Appointment Feedback ",
      path: "/reviewSubmission",
      icon: "ri-feedback-line",
    },
  ];

  const doctorMenu = [
    {
      name: "Home",
      path: "/",
      icon: "ri-home-6-line",
    },
    {
      name: "My Appointments",
      path: "/doctor/appointments",
      icon: "ri-contract-line",
    },
    {
      name: "Appointment Reviews",
      path: "/doctor/markapp-completed",
      icon: "ri-contract-line",
    },
    {
      name: "Profile",
      path: `/doctor/profile/${user?._id}`,
      icon: "ri-user-settings-line",
    },
  ];

  const regDoctorMenu = [
    {
      name: "Home",
      path: "/",
      icon: "ri-home-6-line",
    },
    {
      name: "Apply Appointment",
      path: "/apply-doctor",
      icon: "ri-hospital-line",
    },
  ];

  const staffMenu = [
    {
      name: "Home",
      path: "/staff/home",
      icon: "ri-home-6-line",
    },
    {
      name: "Appointments",
      path: "/staff/appointments-staff",
        icon: "ri-health-book-line",
    },

      {
      name: "Patient List",
      path: "/staff/userlist",
      icon: "ri-user-3-line",
    },

      {
      name: "DoctorList",
      path: "/staff/doctorlist",
      icon: "ri-user-3-line",
    },
   
     {
      name: "Shedule Doctor",
      path: "/staff/doctor-schedule",
      icon: "ri-calendar-2-line",
    },
     
      {
      name: "Patient Feedback",
      path: "/staff/manage-review",
      icon: "ri-list-view",
    },

     {
      name: "Complete Appointment",
      path: "/staff/staff-mark-app-completed",
      icon: "ri-file-chart-line",
    },
  ];

  const adminMenu = [
    {
      name: "Home",
      path: "/admin/home",
      icon: "ri-home-6-line",
    },
    {
      name: "Patient",
      path: "/admin/userslist",
      icon: "ri-user-3-line",
    },
      {
      name: "Staff",
      path: "/admin/stafflist",
      icon: "ri-user-3-line",
    },
       {
      name: "Admin",
      path: "/admin/adminlist",
      icon: "ri-user-3-line",
    },
    {
      name: "Create Staff",
      path: "/admin/staff-register",
      icon: "ri-user-star-fill",
    },
    {
      name: "Add Doctor Slot",
      path: "/admin/slots",
      icon: "ri-coin-line",
    },

    {
      name: "Create Clinic Day",
      path: "/admin/create-clinic-day",
      icon: "ri-coin-line",
    },

    {
      name: "Shedule Doctor",
      path: "/admin/doctor-schedule",
      icon: "ri-calendar-2-line",
    },

    {
      name: "Patient Feedback",
      path: "/admin/manage-review",
      icon: "ri-list-view",
    },
    {
      name: "Doctorslot Status",
      path: "/admin/doctorslots-status",
      icon: "ri-signal-tower-line",
    },
    {
      name: "Manage Doctor",
      path: "/admin/doctorslist",
      icon: "ri-stethoscope-line",
    },
    {
      name: "Appointment",
      path: "/admin/appointments-admin",
      icon: "ri-health-book-line",
    },
    {
      name: "Complete Appointment",
      path: "/admin/admin-mark-app-completed",
      icon: "ri-file-chart-line",
    },
   
    {
      name: "Add Service",
      path: "/admin/service",
      icon: "ri-service-line",
    },
    {
      name: "Add Location",
      path: "/admin/location",
      icon: "ri-map-pin-line",
    },
    {
      name: "Add Speciality",
      path: "/admin/speciality",
      icon: "ri-hospital-line",
    },
    {
      name: "Media Upload",
      path: "/admin/media-image-uploads",
      icon: "ri-git-repository-commits-line",
    },
  ];

  const menuToBeDisplayed =
    filteredMenu.length > 0
      ? filteredMenu
      : user?.isAdmin
      ? adminMenu
      : user?.isDoctor
      ? doctorMenu
      : user?.isStaff
      ? staffMenu
      : user?.regDoctor
      ? regDoctorMenu
      : userMenu;

  const role = user?.isAdmin
    ? "Admin"
    : user?.isDoctor
    ? "Doctor"
    : user?.isStaff
    ? "Staff"
    : user?.regDoctor
    ? "Reg Doctor"
    : "User";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem(`notificationDismissed_${user._id}`);
    toast.success("You have been logged out");
    toast("Redirecting to Login Page");
    navigate("/login");
    window.location.reload(); // Reload the page to kill the session
  };

  const handleSearch = (e) => {
    const keyword = e.target.value.toLowerCase();
    setSearchInput(keyword);

    if (keyword === "") {
      setFilteredMenu([]); // Reset search results to default when search input is empty
    } else {
      setFilteredMenu(
        menuToBeDisplayed.filter((menu) =>
          menu.name.toLowerCase().includes(keyword)
        )
      );
    }
  };


  return (
        <>
      <NotificationPopup />
    <div className="main">
      <div className="d-flex layout">
      <div className={`sidebar ${collapsed ? "" : "active"}`}>

          <div className="sidebar-header">
            <button className="toggle-btn" onClick={() => setCollapsed(!collapsed)}>
  <i className="ri-menu-line"></i>
</button>

            <h1 className="logo">AM</h1><br/>
            <h3 className="role">{role}</h3>
          </div>
          <div className="menu">
            {menuToBeDisplayed.map((menu, index) => {
              const isActive = location.pathname === menu.path;
              return (
                <div
                  key={index} // Add a unique key prop here
                  className={`d-flex menu-item ${
                    isActive && "active-menu-item"
                  }`}
                >
                  <i className={menu.icon}></i>
                  {!collapsed && <Link to={menu.path}>{menu.name}</Link>}
                  {collapsed && <Link to={menu.path}></Link>}
                </div>
              );
            })}
<div className="d-flex menu-item cursor-pointer" onClick={handleLogout}>
  <i className="ri-logout-circle-line"></i>
  {!collapsed && <span className="ms-2">Logout</span>}
</div>

          </div>
        </div>

        <div className="content">
          <div className="header">
          {collapsed ? (
    <i
      className="ri-menu-2-fill close-icon"
      onClick={() => setCollapsed(false)}
    ></i>
  ) : (
    <i
      className="ri-close-fill close-icon"
      onClick={() => setCollapsed(true)}
    ></i>
  )}
           <div className="search-bar">
    <input
      className="search-input"
      type="text"
      placeholder="Menu Search..."
      value={searchInput}
      onChange={handleSearch}
    />
  </div>
           <div className="d-flex align-items-center px-4">
  <NotificationBell />
  <Link className="anchor mx-3" to="/profile">
    {user?.name}
  </Link>
</div>
          </div>
          <div className="body">{children}</div>
        </div>
      </div>
    </div>
    </>
  );
    
}

export default Layout;
